
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-ryerson/ryerson-commitment/certification-compliance",
      function () {
        return require("private-next-pages/why-ryerson/ryerson-commitment/certification-compliance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-ryerson/ryerson-commitment/certification-compliance"])
      });
    }
  